module.exports = __webpack_public_path__ + "img/tool3.5f353026.png";